import { useContext } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { type IDV2InitialValues, type IDV2Store, StoreContext } from './idv2-provider';

// Must be a stable reference: building l10n inline makes useShallow see a new value on every
// store write, which spins the router sync into an infinite re-render loop.
const defaultL10n: IDV2InitialValues['l10n'] = {
  language: 'en'
};

/**
 * Syncs store values to TanStack Router context.
 * Includes navigation for legacy IDV → IDV2 handoff.
 */
export const useIdvToIdv2Sync = () => {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error("useIdvToIdv2Sync must be used within Idv2Provider");
  }
  const selector = useShallow(_temp);
  return useStore(store, selector);
};
function _temp(state) {
  return {
    onboardingSessionToken: state.initialValues.onboardingSessionToken,
    config: state.initialValues.config,
    overallOutcome: state.initialValues.overallOutcome,
    fixtureRiskSignals: state.initialValues.fixtureRiskSignals,
    idDocOutcome: state.initialValues.idDocOutcome,
    onHandoffComplete: state.onHandoffComplete,
    onComplete: state.onComplete,
    l10n: state.initialValues.l10n ?? defaultL10n,
    obConfigAuth: state.initialValues.obConfigAuth,
    navigation: state.data.navigation,
    kycBootstrapData: state.initialValues.kycBootstrapData,
    kybBootstrapData: state.initialValues.kybBootstrapData,
    sandboxId: state.initialValues.sandboxId,
    isComponentsSdk: state.initialValues.isComponentsSdk,
    componentsSdkRelay: state.componentsSdkRelay
  };
}